import React, { useEffect, useRef, useState, useContext } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import AuthContext from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import loginImg from "../assets/images/login-img.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { isEmpty } from "lodash";
import { Helmet } from "react-helmet";
import { isMobile } from "react-device-detect";
const Login = () => {
  const navigate = useNavigate();
  let { loginUser, user } = useContext(AuthContext);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      uniqueId: Math.random() * 10000,
    },
  });
  const handleShow = () => {
    setShowPassword(!showPassword);
  };
  const [showPassword, setShowPassword] = useState(true);
  const onSubmit = (data) => {
    loginUser(data);
  };

  useEffect(() => {
    if (!isEmpty(user)) {
      navigate("/");
    }
  }, [user]);

  return (
    <div
      style={{ height: "100vh", background: "#303030" }}
      className="d-flex justify-content-center align-items-center w-100"
    >   <Helmet>
        <meta
          name="viewport"
          content="width=device-width, minimum-scale=1.0, maximum-scale = 1.0, user-scalable = no"
        />
      </Helmet>
      <Container className="h-100 align-middle">
        <Row className="h-100 align-items-center align-middle justify-content-center d-flex" style={isMobile ? {flexDirection:"column"} : {flexDirection:"row"}}>
          {!isMobile &&
          <Col md={7} className="text-start">
            <img
              data-aos="zoom-in-down"
              src={loginImg}
              style={{ width: "80%" }}
            />
          </Col>}
          <Col md={5}>
            {" "}
            <div data-aos="flip-up" className="text-center mb-4">
              <img src="./assets/images/logo.png" style={{ width: "220px" }} />
            </div>
            <Form
              style={{
                background: "white",
                padding: "20px",
                borderRadius: "5px",
              }}
              onSubmit={handleSubmit(onSubmit)}
            >
              {" "}
              <div className="d-flex flex-column align-items-center mb-4">
                <h5 style={{ fontWeight: "600" }} className="m-0">
                  Welcome
                </h5>
                <span>Login in to you account to continue</span>
              </div>
              <div class="form-group">
                <label style={{ marginBottom: "10px" }} for="email">
                  User Name:
                </label>
                <Form.Group className="mb-2">
                  <Form.Control
                    type="text"
                    placeholder="Username"
                    className={errors.username ? "is-invalid" : ""}
                    {...register("username", {
                      required: "Please enter Username",
                    })}
                  />
                  {errors.username && errors.username.message && (
                    <label className="invalid-feedback text-left">
                      {errors.username.message}
                    </label>
                  )}
                </Form.Group>
              </div>
              <div class="form-group">
                <label style={{ marginBottom: "10px" }} for="pwd">
                  Password:
                </label>
                {/* <Form.Group className="mb-2">
              <Form.Control
                type="password"
                placeholder="Password"
                className={errors.password ? "is-invalid" : ""}
                {...register("password", {
                  required: "Please enter password",
                })}
              />
              {errors.password && errors.password.message && (
                <label className="invalid-feedback text-left">
                  {errors.password.message}
                </label>
              )}
            </Form.Group> */}

                <Form.Group className="mb-2 position-relative">
                  {/* <FloatingLabel> */}
                  <Form.Control
                    type={!showPassword ? "text" : "password"}
                    placeholder="Password"
                    maxLength={15}
                    {...register("password", {
                      required: "Please enter password",
                    })}
                    className={errors.password ? "is-invalid" : ""}
                  />
                  <Button
                    className="position-absolute translate-middle-y top-50 end-0 me-2 bg-transparent border-0 text-dark p-0 "
                    onClick={() => handleShow()}
                  >
                    {!showPassword ? (
                      <FaEye className="opacity-100 fs-5" size="17" />
                    ) : (
                      <FaEyeSlash className="opacity-100 fs-5" size="17" />
                    )}
                  </Button>
                  {/* </FloatingLabel> */}
                  {errors.password && errors.password.message && (
                    <label className="invalid-feedback text-left">
                      {errors.password.message}
                    </label>
                  )}
                </Form.Group>
              </div>
              <div>
                <button
                  type="submit"
                  tabindex="3"
                  style={{
                    backgroundImage: "linear-gradient(#022c43, #12243c)",
                    color: "white",
                    width: "100%",
                    padding: "6px",
                    border: "none",
                  }}
                  class="text-center login-bt"
                >
                  LOGIN
                </button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
